import React, { FC, ReactNode } from 'react';

import { FooterLarge } from './FooterLarge';
import { FooterSmall } from './FooterSmall';
import { LegalProps } from './Legal';

export enum FooterTemplate {
  LegalDisclaimerOnly = 'LegalDisclaimerOnly',
  LegalDisclaimerAndContacts = 'LegalDisclaimerAndContacts',
  Full = 'Full',
}

export interface FooterProps extends LegalProps {
  template?: keyof typeof FooterTemplate;
  displayDepositAccountDetails?: boolean;
  additionalFootnotes?: ReactNode[];
}

export const Footer: FC<FooterProps> = ({
  displayDepositAccountDetails,
  template = FooterTemplate.Full,
  ...props
}) => (
  <>
    <FooterSmall
      {...props}
      template={template}
      displayDepositAccountDetails={displayDepositAccountDetails}
    />
    <FooterLarge
      {...props}
      template={template}
      displayDepositAccountDetails={displayDepositAccountDetails}
    />
  </>
);
